import { render, staticRenderFns } from "./gwAIAssistant.vue?vue&type=template&id=0c920448&scoped=true"
import script from "./gwAIAssistant.vue?vue&type=script&lang=js"
export * from "./gwAIAssistant.vue?vue&type=script&lang=js"
import style0 from "./gwAIAssistant.vue?vue&type=style&index=0&id=0c920448&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c920448",
  null
  
)

export default component.exports